import styled from 'styled-components';
import { Grid } from 'styled-css-grid';
import { NavLink } from 'react-router-dom';

import { colors, ScrollbarStyle, sizes } from '@crm-framework/theme';

export const ChatWrapper = styled.div<{ height?: number }>`
  height: ${({ height }) => `${height}px`};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  background-color: ${colors.INFO_BORDER};
  padding-bottom: 10px;
`;

export const MessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 10px;
  overflow-x: auto;

  ${ScrollbarStyle}
`;

export const ChatItem = styled.div`
  margin: 5px 0;
  padding: 0 5px;
  display: flex;
  flex-direction: row;
  gap: 7px;
  border-radius: ${sizes.DEFAULT_BORDER_RADIUS};
  align-items: center;
  border: 1px solid ${colors.PRIMARY_BORDER};

  &:hover {
    background-color: ${colors.PRIMARY_BORDER};
  }
`;

export const ChatData = styled.div`
  width: 100%;
  display: flex;
  padding: 5px;
  flex-direction: column;
`;

export const ChatTitle = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const ChatInputBlock = styled(Grid)``;

export const EmptyChats = styled.div`
  margin-top: 10px;
  text-align: center;
`;

export const ChatContentWrapper = styled(Grid)`
  height: 100%;
`;

export const ActiveChatWrapper = styled(Grid)`
  height: 100%;
`;

export const ChatListWrapper = styled(Grid)`
  height: 92%;
`;

export const LeadNavLink = styled(NavLink)`
  text-decoration: none;
  color: inherit;
  &:hover {
    text-decoration: underline;
  }
`;

export const ChatBody = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const ChatListMessage = styled.div<{ isNotRead?: boolean }>`
  width: 320px;
  font-weight: ${({ isNotRead = false }) => (isNotRead ? 'bold' : 'normal')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ChatListMessageWithReadMark = styled.div<{ isNotRead?: boolean }>`
  display: flex;
`;

export const ChatMessage = styled.div`
  max-width: 320px;
  overflow: hidden;
  white-space: normal;
  word-break: break-all;
`;

export const BubbleDate = styled.small`
  font-size: 9px;
  /* color: #707579 !important; */
`;

export const CountWrapper = styled.div`
  width: 20px;
  height: 20px;
  color: white;
  line-height: 19px;
  background-color: ${colors.SUCCESS};
  text-align: center;
  border-radius: 10px;
  font-weight: bold;
`;

export const MessagePositionWrapper = styled.div<{ isIncoming: boolean }>`
  display: flex;
  flex-direction: ${({ isIncoming }) => (isIncoming ? 'row' : 'row-reverse')};
`;

export const ChatHeader = styled.h3`
  display: block;
  overflow: hidden;
  whitespace: nowrap;
  textoverflow: ellipsis;
  margin: 0;
`;

export const BubleWrapper = styled.div<{ isIncoming: boolean }>`
  background-color: ${({ isIncoming }) =>
    isIncoming ? 'white' : colors.PRIMARY};
  border-radius: 10px;

  color: ${({ isIncoming }) => (isIncoming ? '#707579' : 'white')};
  display: inline-flex;
  flex-direction: column;
  max-width: Min(400px, 80%);
  padding: 5px 10px;
  position: relative;
  ${({ isIncoming }) =>
    isIncoming ? 'border-end-start-radius: 0;' : 'border-end-end-radius: 0;'};

  &:after {
    border-color: transparent transparent
      ${({ isIncoming }) =>
        isIncoming ? 'white transparent' : ` transparent ${colors.PRIMARY}`};
    border-style: solid;
    border-width: ${({ isIncoming }) =>
      isIncoming ? `0 0 5px 7px` : '5px 0 0 7px'};
    bottom: 0;
    content: '';
    display: block;
    position: absolute;
    width: 0;
    z-index: 1;
    left: ${({ isIncoming }) => (isIncoming ? `-6px` : 'auto')};

    ${({ isIncoming }) => (isIncoming ? '' : 'right: -6px;')};
  }
`;

export const BubleCallWrapper = styled(BubleWrapper)`
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const MessageInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  min-width: 80px;
`;

export const BubleContent = styled.p`
  margin-top: 0;
  margin-bottom: 5px;
  max-width: 320px;
  overflow: hidden;
  white-space: pre-wrap;
  word-break: break-all;
`;

export const BadgeWrapper = styled.div`
  margin: 0 auto;
`;

export const SearchWrapper = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
`;
